import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'rebass'
import Modal from '../../components/Modal'
import { AutoColumn } from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { CloseIcon } from '../../theme/components'

interface OrderHelpModalProps {
  isOpen: boolean
  onDismiss: () => void
}

export default function OrderHelpModal({ isOpen, onDismiss }: OrderHelpModalProps) {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <div style={{ width: '100%', padding: 24 }}>
        <RowBetween>
          <Text fontWeight={500} fontSize={20}>
            {t('orderHelpDetailTitle')}
          </Text>
          <CloseIcon onClick={onDismiss} />
        </RowBetween>
        <AutoColumn gap="12px" style={{ marginTop: 20 }}>
          <Text fontSize={14} color="var(--text1)" lineHeight="1.5">
            {t('orderHelpDetailP1')}
          </Text>
          <span style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 600, color: '#e53935' }}>
            {t('orderHelpDetailP2')}
          </span>
          <Text fontSize={14} color="var(--text1)" lineHeight="1.5">
            {t('orderHelpDetailP3')}
          </Text>
          <Text fontSize={14} color="var(--text1)" lineHeight="1.5">
            {t('orderHelpDetailP4')}
          </Text>
          <Text fontSize={14} color="var(--text1)" lineHeight="1.5">
            {t('orderHelpDetailP5')}
          </Text>
        </AutoColumn>
      </div>
    </Modal>
  )
}
